export default "__VITE_ASSET__09cfd2f4__"